import React from "react";
import { PIF_LIST_STATUS_LABEL, PifListStatus } from "../../pages/supervision/PostInterviewForm/types";
import "./PostIFStatusChip.scss";

// Bug 84702: one colour per meaning on every screen - waiting stages are blue (they were amber,
// the "returned" colour) and Completed is green like Approved (it was blue).
const STATUS_CLASS: Record<PifListStatus, string> = {
  DRAFT: "postif-chip--draft",
  RETURNED: "postif-chip--returned",
  "PENDING DEPT DIR": "postif-chip--awaiting",
  "PENDING HR DIR": "postif-chip--awaiting",
  "PENDING EXEC DIR": "postif-chip--awaiting",
  APPROVED: "postif-chip--approved",
  COMPLETED: "postif-chip--completed",
  DECLINED: "postif-chip--declined",
};

interface PostIFStatusChipProps {
  status: PifListStatus;
  /** Extra class for a host that sizes the chip differently (the approval screen's header). */
  className?: string;
}

const PostIFStatusChip: React.FC<PostIFStatusChipProps> = ({ status, className }) => (
  <span
    className={`postif-chip ${STATUS_CLASS[status]}${className ? ` ${className}` : ""}`}
    data-testid="postif-badge-status"
  >
    {PIF_LIST_STATUS_LABEL[status]}
  </span>
);

export default PostIFStatusChip;
